import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MonitorSmartphone } from "lucide-react";

// Installation PWA sur l'écran d'accueil (Android/Chrome via beforeinstallprompt, iOS via consigne)
export default function InstallButton({ className = "" }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); toast.success("Application installée sur l'écran d'accueil"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed) return null;
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);

  const install = async () => {
    if (prompt) { prompt.prompt(); await prompt.userChoice; return; }
    toast.message(isIos ? "Sur iPad : bouton Partager → « Sur l'écran d'accueil »." : "Menu du navigateur (⋮) → « Installer l'application » ou « Ajouter à l'écran d'accueil ».", { duration: 8000 });
  };

  return (
    <button data-testid="install-app-btn" onClick={install}
      className={`w-full flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium text-dd-night hover:bg-dd-light/60 ${className}`}>
      <MonitorSmartphone size={18} /> Installer sur la tablette
    </button>
  );
}
